// extracted by mini-css-extract-plugin
export default {"root":"uN_0JZ","orderNumber":"KHmkKk","date":"DE0hXm","total":"yF2j6y","button":"laOyK9"};